// extracted by mini-css-extract-plugin
export default {"cardcontainer":"ccf-contact-history_cardcontainer__tqXNL","cardcontainerAppSpace":"ccf-contact-history_cardcontainerAppSpace__YpxHx"};